import { isNullOrUndefined } from 'util';

export type ProductComponents = ProductComponent[];

export class ProductComponent {
  isEditing: boolean = false;
  name: string = '';







  // DTO properties
  amount: number;
  component_id: number;
  component_name: string;
  delivered: number
  description: string;
  order_amt: number;
  order_status: string;
  product_id: number;
  product_name: string;
  product_qty: number
  quantity: number;
  qty: number;
  total_amount: number
  total_amt: number
  total_delivered_quantity: string




  errors: string[] = [];

  get firstError(): string {
    if (this.errors && this.errors.length > 0) {
      return `* ${this.errors[0]}`;
    }
    return null;
  }

  validate(components: ProductComponent[]): void {
    this.errors = [];

    if (isNullOrUndefined(this.name) || this.name.trim() === '') {
      this.errors.push('Component name required.');
    }

    const names = components
      .filter(c => c !== this)
      .map(c => c.name.trim().toLowerCase());

    if (names.includes(this.name.trim().toLowerCase())) {
      this.errors.push('Duplicate name');
    }
  }

  constructor(init?: Partial<ProductComponent>) {
    Object.assign(this, init);
  }
}